import { get, cloneDeep } from "lodash";
import { store } from "@irati/store";
import env from "@irati/utils/env";
import { SANDBOX, PRODUCTION } from "@irati/utils/constants/environment";
import tenantService from "@irati/identity/services/tenant";
import isSamlUserHelper from "@irati/identity/helpers/user/isSamlUser";
import locale from "@irati/utils/locale";
import { CurrencyType } from "@irati/payments/enums";
import paymentProviderForCountryCode from "@irati/payments/helpers/paymentProviderForCountryCode";
import AuthActions from "./store/actions/AuthActions";
import defaultUser from "./helpers/defaultUser";
import { hasAdminRole as userHasAdminRole, hasManagerRole as userHasManagerRole, hasSuperAdminRole as userHasAdminSuperRole } from "../identity/helpers/user/role";
var apps = function (key) {
    if (key === void 0) { key = ""; }
    var auth = store.getState().auth;
    return key.length ? get(auth.apps, key, false) : auth.apps;
};
var userProducts = function () {
    var _a = apps(), perks = _a.perks, recognition = _a.recognition, medical = _a.medical, insights = _a.insights;
    return [
        {
            product: "perks",
            active: !!perks
        },
        {
            product: "recognition",
            active: !!recognition
        },
        {
            product: "medical",
            active: !!medical
        },
        {
            product: "insights",
            active: !!insights
        }
    ];
};
var user = function () {
    var auth = store.getState().auth;
    return auth.user || defaultUser;
};
var userSessionId = function () {
    var auth = store.getState().auth;
    return auth.sessionId || "";
};
var userEmail = function () {
    return user().email;
};
var userTenant = function (key) {
    if (key === void 0) { key = ""; }
    var auth = store.getState().auth;
    return key.length ? get(auth.userTenant, key, false) : auth.userTenant;
};
var upsell = function () {
    var auth = store.getState().auth;
    return auth.upsell || {};
};
var userUnits = function () {
    // @todo: Need to integrate a proper units system. Hardcoding for now.
    return {
        distance: locale.units.miles
    };
};
var featureFlag = function (key) {
    var auth = store.getState().auth;
    return get(auth.featureFlags, key, false);
};
var userLocale = function () {
    return user().locale || userTenant().locale;
};
var userPaymentProvider = function () {
    return paymentProviderForCountryCode();
};
var defaultUserCurrency = function () {
    switch (userLocale()) {
        case "fr-FR":
            return CurrencyType.EUR;
        case "en-AU":
            return CurrencyType.AUD;
        case "en-GB":
        default:
            return CurrencyType.GBP;
    }
};
var updateTenantSettings = function (tenantSettings) {
    var tenantClone = cloneDeep(userTenant());
    tenantClone.settings = tenantSettings;
    store.dispatch(AuthActions.UpdateAuthAction({
        userTenant: tenantClone
    }));
};
var isSamlUser = function () {
    return isSamlUserHelper(user());
};
var didLoginWithSSO = function () {
    var auth = store.getState().auth;
    return auth && !!auth.isSSO;
};
var isLoggedIn = function () {
    var hasUser = !!user().uuid || isInternal();
    return hasUser;
};
var isGlobal = function () {
    return !tenantService.getTenantFromPath();
};
var hasAdminAccess = function () {
    return !!apps().admin;
};
var hasSuperAdminRole = function () { return userHasAdminSuperRole(user()); };
var hasAdminRole = function () { return userHasAdminRole(user()); };
var hasManagerRole = function () { return userHasManagerRole(user()); };
var isUserGhost = function () {
    return user().uuid === "ghost";
};
var isInternal = function () {
    return tenantService.getTenantFromPath() === "admin";
};
var isSandbox = function () {
    return env.ENVIRONMENT_NAME === SANDBOX;
};
var isDevDomain = function () {
    return tenantService.getTenantFromPath() === "dev" && env.ENVIRONMENT_NAME !== PRODUCTION;
};
var isMerchant = function () {
    return tenantService.getTenantFromPath() === "merchant";
};
// TODO: onboard type need to be created
var getOnboarding = function () {
    var onboarding = store.getState().auth.onboarding;
    return onboarding;
};
var authentication = {
    userTenant: userTenant,
    featureFlag: featureFlag,
    userSessionId: userSessionId,
    isLoggedIn: isLoggedIn,
    isSamlUser: isSamlUser,
    didLoginWithSSO: didLoginWithSSO,
    user: user,
    userLocale: userLocale,
    userPaymentProvider: userPaymentProvider,
    userEmail: userEmail,
    upsell: upsell,
    updateTenantSettings: updateTenantSettings,
    hasAdminAccess: hasAdminAccess,
    hasManagerRole: hasManagerRole,
    hasAdminRole: hasAdminRole,
    hasSuperAdminRole: hasSuperAdminRole,
    isUserGhost: isUserGhost,
    isInternal: isInternal,
    isGlobal: isGlobal,
    apps: apps,
    userUnits: userUnits,
    isSandbox: isSandbox,
    userProducts: userProducts,
    defaultUserCurrency: defaultUserCurrency,
    isMerchant: isMerchant,
    getOnboarding: getOnboarding,
    isDevDomain: isDevDomain
};
export default authentication;
